// AI chat API client — single-agent architecture (multi-session).
// Must stay above backend AiChatService.AGENT_TIME_BUDGET_SECONDS (ai_chat_service.py)
// plus a margin, or the frontend aborts before a long-running agent turn finishes.
export const CHAT_REQUEST_TIMEOUT_MS = 450000;

export async function listSessions(request, workspaceId) {
    return request(`/api/v1/ai/sessions?workspace_id=${workspaceId}`);
}

export async function createSession(request, workspaceId, title) {
    return request('/api/v1/ai/sessions', {
        method: 'POST',
        body: JSON.stringify({ workspace_id: workspaceId, title: title || 'Новый чат' }),
    });
}

export async function deleteSession(request, sessionId) {
    return request(`/api/v1/ai/sessions/${sessionId}`, { method: 'DELETE' });
}

export async function renameSession(request, sessionId, title) {
    return request(`/api/v1/ai/sessions/${sessionId}`, {
        method: 'PATCH',
        body: JSON.stringify({ title }),
    });
}

export async function listMessages(request, sessionId) {
    return request(`/api/v1/ai/sessions/${sessionId}/messages`);
}

export async function clearMessages(request, sessionId) {
    return request(`/api/v1/ai/sessions/${sessionId}/messages`, { method: 'DELETE' });
}

export async function compactSession(request, sessionId) {
    return request(`/api/v1/ai/sessions/${sessionId}/compact`, { method: 'POST' });
}

export async function sendMessage(request, sessionId, content) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), CHAT_REQUEST_TIMEOUT_MS);
    try {
        return await request(`/api/v1/ai/sessions/${sessionId}/messages`, {
            method: 'POST',
            body: JSON.stringify({ content }),
            signal: controller.signal,
        });
    } catch (error) {
        if (error.name === 'AbortError') {
            throw new Error('Превышено время ожидания ответа ИИ. Попробуйте ещё раз.');
        }
        throw error;
    } finally {
        clearTimeout(timer);
    }
}

export async function getProgress(request, sessionId) {
    return request(`/api/v1/ai/sessions/${sessionId}/progress`);
}

export async function sendMessageFeedback(request, sessionId, messageId, vote, comment) {
    return request(`/api/v1/ai/sessions/${sessionId}/messages/${messageId}/feedback`, {
        method: 'POST',
        body: JSON.stringify({ vote, comment: comment || null }),
    });
}

// ── Публичные ссылки на чат (только чтение) ──

export async function createShare(request, sessionId, expiresInDays) {
    return request(`/api/v1/ai/sessions/${sessionId}/shares`, {
        method: 'POST',
        body: JSON.stringify({ expires_in_days: expiresInDays }),
    });
}

export async function listShares(request, sessionId) {
    return request(`/api/v1/ai/sessions/${sessionId}/shares`);
}

export async function revokeShare(request, shareId) {
    return request(`/api/v1/ai/shares/${shareId}`, { method: 'DELETE' });
}
